import { Endpoint } from '../endpoint';
import { AssistantId, AssistantResponse } from '@business/entities/assistant';

export function fetchAssistant(id: AssistantId) {
  return Endpoint.get<AssistantResponse>(`@gc/assistants/assistant/${id}`);
}

export function functionCall(fnName: string, args: any) {
  return Endpoint.post<{ result: string }>(`@gc/assistants/function-call`, { data: { fnName, args } });
}

export function search(query: string, limit: number, types: string[] = []) {
  return Endpoint.post<any>(`@gc/assistants/search`, { data: { query, limit, types } });
}

export function start(assistanId: string, threadId: string, contextId?: string) {
  return Endpoint.post<any>(`@gc/assistants/start/${assistanId}`, { data: { threadId, contextId } });
}

export function stop(assistantId: string, threadId: string, lastResponseId: string) {
  return Endpoint.post<any>(`@gc/assistants/stop/${assistantId}`, { data: { threadId, lastResponseId } });
}

export function track(assistanId: string, threadId: string, time = 0) {
  return Endpoint.post<any>(`@gc/assistants/track/${assistanId}`, { data: { threadId, time } });
}

export function onNewMessage(assistantId: string, lastResponseId: string, sessionId: string) {
  return Endpoint.post<any>(`@gc/assistants/on-new-message/${assistantId}`, { data: { lastResponseId, sessionId } });
}
